export default "__VITE_ASSET__Bx86XIHp__"